var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-footer"},[_c('p',[_vm._v("© "+_vm._s(new Date().getFullYear())+" Sloan Interactive, LLC.")])])}
var staticRenderFns = []

export { render, staticRenderFns }